// @flow

import {showNotification} from 'app/toasts/slice';
import {gt} from 'app/utils/i18n';
import * as request from 'app/utils/request';
import * as urls from 'app/urls';
import {limitRequests} from '../utils/redux';
import type {VersionContentType, DocumentContentType} from './types';

import {requestVersionAcceptanceFetcher} from 'app/acceptance/fetchers';

export const RECEIVE_ACCEPTANCE = 'RECEIVE_ACCEPTANCE';

export type AcceptanceActionType = {
  +type: 'RECEIVE_ACCEPTANCE',
  id: number,
  contentType: DocumentContentType,
  data: any,
};

export const setAcceptanceStatus =
  (
    url: string,
    status: boolean,
    documentId: number,
    contentType: DocumentContentType
  ) =>
  (dispatch: SimpleDispatch): Promise<any> =>
    request
      .patchJson(url, {status: status})
      .then(() => dispatch(loadAcceptance(documentId, contentType)))
      .catch(
        request.createErrorHandler(
          gt('Could not confirm this version'),
          dispatch
        )
      );

export const setAcceptanceVersionViewed =
  (url: string, documentId: number, contentType: DocumentContentType) =>
  (dispatch: SimpleDispatch) =>
    request
      .patchJson(url, {seen_at: new Date()})
      .then(() => dispatch(loadAcceptance(documentId, contentType)))
      .catch(
        request.createErrorHandler(gt('Could not update seen status'), dispatch)
      );

export const requestVersionAcceptance =
  (
    versionId: number,
    versionContentType: VersionContentType,
    message: string,
    user_ids: Array<string>
  ) =>
  (dispatch: SimpleDispatch) =>
    requestVersionAcceptanceFetcher({
      object_id: versionId,
      content_type: versionContentType,
      message,
      user_ids,
    })
      .then(() => {
        return dispatch(
          showNotification(
            gt('An approval request was sent to the selected managers')
          )
        );
      })
      .catch(
        request.createErrorHandler(gt('Could not request approval.'), dispatch)
      );

export const receiveAcceptance = (
  id: number,
  contentType: DocumentContentType,
  data: any
) => ({
  type: RECEIVE_ACCEPTANCE,
  id,
  contentType,
  data,
});

export const loadAcceptance = limitRequests(
  (object_pk: number, content_type: DocumentContentType) =>
    (dispatch: Function) => {
      const params = {object_pk, content_type};
      return request
        .get(urls.ACCEPTANCE_API_URL, params)
        .then((data) =>
          dispatch(receiveAcceptance(object_pk, content_type, data))
        )
        .catch(
          request.createErrorHandler(
            gt('Could not load %(content_type)s approvals', {content_type}),
            dispatch
          )
        );
    },
  10
);
